import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Avatar, Tooltip, Typography, Stack } from '@mui/material';
import { getTypeConfig } from 'src/utils/common';

const ClientVoucherEntityTypeIcon = ({ value }) => {
    const theme = useTheme();
    const typeConfig = getTypeConfig(theme);
    const config = typeConfig[value + "s"];
    
    if (!config) return null;

    return (
        <Stack
            direction="row"
            spacing={0}
            sx={{
                flexWrap: 'wrap',
                gap: 1,
                alignItems: 'center',
                maxWidth: '100%'
            }}
        >
            <Tooltip title={config.label}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0,
                    px: 0.5,
                    py: 0.1,
                    borderRadius: 4,
                    bgcolor: config.bgColor,
                    border: `0.8px solid ${config.color}20`,
                    minWidth: 10,
                    boxShadow: theme.shadows[1]
                }}>
                    <Avatar
                        sx={{
                            bgcolor: "#fff",
                            color: config.color,
                            width: 29,
                            height: 29,
                        }}
                    >
                        {React.cloneElement(config.icon, {
                            size: 23,
                            color: config.color
                        })}
                    </Avatar>
                </Box>
            </Tooltip>
        </Stack>
    )
}

export default ClientVoucherEntityTypeIcon